import api from '../../../App/socket';
import { LEAD_STATUS, LEAD_CANCELLATION_STATUSES } from '../../constants/leadStatuses';

export const setLeadStatus = (_id, status_id, requestParams = {}) => {
    let update = {};

    if (status_id === LEAD_STATUS.doNotWantTrade) {
        update = {
            lead_pot: 'Black',
            // damaged bike: 5beabf6166676f89160edfc7
            ref_lead_status: status_id,
            'trade.is_trade': status_id === '5fd27dc61dc278430e324b21' || status_id === '5beabe6d66676f89160edd7f' || status_id === LEAD_STATUS.damagedBike || status_id === '5beabf6166676f89160edfc1' || status_id === '5beabf6166676f89160edfc0' || status_id === '5beabef666676f89160edfbf' || status_id === '5beabf6166676f89160edfc3' || status_id === '5beabef666676f89160edfbf' || status_id === '5beabf6166676f89160edfc3' || status_id === '5f92fded338def1a9607ae36' || status_id === '5f92fb12338def1a9607ae34' || status_id === '5f92fafd338def1a9607ae33' || status_id === '5f92fafd338def1a9607ae33' || status_id === '5f8863f1d88a9007b68aa742' || status_id === '5f886198d88a9007b68aa741' || status_id === '5f886009d88a9007b68aa740' || status_id === '5f885dc8d88a9007b68aa73f' || status_id === '5f85a3ead88a9007b68aa73d' || status_id === '5f858829d88a9007b68aa73c' || status_id === '5f8582b8d88a9007b68aa73b' || status_id === '5f85823bd88a9007b68aa73a' || status_id === '5f85820bd88a9007b68aa739' || status_id === '5f858198d88a9007b68aa738' || status_id === '5f8578e3d88a9007b68aa737' || status_id === '5f8574fcd88a9007b68aa736' || status_id === LEAD_STATUS.doNotWantTrade || status_id === LEAD_STATUS.pendingTrade || status_id === '5f8574aed88a9007b68aa733' || status_id === LEAD_STATUS.scrapBike || status_id === '5f8574e3d88a9007b68aa735',
        };
    } else {
        update = {
            ref_lead_status: status_id,
            'trade.is_trade': status_id === '5fd27dc61dc278430e324b21' || status_id === '5beabe6d66676f89160edd7f' || status_id === LEAD_STATUS.damagedBike || status_id === '5beabf6166676f89160edfc1' || status_id === '5beabf6166676f89160edfc0' || status_id === '5beabef666676f89160edfbf' || status_id === '5beabf6166676f89160edfc3' || status_id === '5beabef666676f89160edfbf' || status_id === '5beabf6166676f89160edfc3' || status_id === '5f92fded338def1a9607ae36' || status_id === '5f92fb12338def1a9607ae34' || status_id === '5f92fafd338def1a9607ae33' || status_id === '5f92fafd338def1a9607ae33' || status_id === '5f8863f1d88a9007b68aa742' || status_id === '5f886198d88a9007b68aa741' || status_id === '5f886009d88a9007b68aa740' || status_id === '5f885dc8d88a9007b68aa73f' || status_id === '5f85a3ead88a9007b68aa73d' || status_id === '5f858829d88a9007b68aa73c' || status_id === '5f8582b8d88a9007b68aa73b' || status_id === '5f85823bd88a9007b68aa73a' || status_id === '5f85820bd88a9007b68aa739' || status_id === '5f858198d88a9007b68aa738' || status_id === '5f8578e3d88a9007b68aa737' || status_id === '5f8574fcd88a9007b68aa736' || status_id === LEAD_STATUS.doNotWantTrade || status_id === LEAD_STATUS.pendingTrade || status_id === '5f8574aed88a9007b68aa733' || status_id === LEAD_STATUS.scrapBike || status_id === '5f8574e3d88a9007b68aa735',
        };
    }

    // On clicking Scrap button -> ref_lead_status: 'Pending (Trade), is_trade: true, lead_pot: Black
    if (status_id === LEAD_STATUS.pendingTrade && requestParams.lead_pot === 'Black') {
        update.lead_pot = requestParams.lead_pot;
    }

    // On Cancelling
    const isCollectionCancelled = LEAD_CANCELLATION_STATUSES.includes(status_id);

    if (isCollectionCancelled && requestParams.reject_reason) {
        update.reject_reason = requestParams.reject_reason;
        update.collection_cancelled_date = new Date();
    }

    return api.send({
        api: 'db',
        model: 'Lead',
        action: 'Update',
        options: {
            where: { _id },
            update,
        },
    }).then((response) => response).catch((error) => error);
};

export const setLeadDuplicate = (_id, is_duplicate) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Update',
        options: {
            where: { _id },
            update: { is_duplicate },
        },
    }).then((response) => response).catch((error) => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/change_leads_status_request.js